<template>
  <div class="main-cotent">
    <img src="./images/8.png" />
    <img src="./images/9.png" />
    <input
      type="text"
      class="input-1"
      placeholder="您的手机号"
      v-model.trim="phone"
      @keyup="checkPhone"
      maxlength="11"
    />
    <input
      type="text"
      class="input-1 input-2"
      placeholder="请输入验证码"
      v-model.trim="code"
      @keyup="checkCode"
      maxlength="6"
    />
    <button class="btn-1" @click="getCode">{{ codeText }}</button>
    <button class="btn-2" @click="receive"></button>
  </div>
</template>

<script>
import { sendSmsCodeWashCar, checkSmsCode } from "@/services/C2C";
import { addSensorsTrack } from "@/libs/utils";

export default {
  name: "carService",
  data() {
    return {
      phone: "",
      code: "",
      codeText: "获取验证码",
      time: 60
    };
  },
  methods: {
    checkPhone(e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
    },
    checkCode(e) {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
    },
    //获取验证码
    getCode() {
      if (this.time < 60) {
        return false;
      }
      if (!this.phone) {
        this.$toast("请输入手机号");
        return false;
      }
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (!reg.test(this.phone)) {
        this.$toast("请输入正确的手机号");
        return false;
      }
      const interval = setInterval(() => {
        if (this.time === 0) {
          this.codeText = "获取验证码";
          this.time = 60;
          clearInterval(interval);
        } else {
          this.time--;
          this.codeText = this.time + "秒后重发";
        }
      }, 1000);

      const data = "phoneNum=" + this.phone;

      sendSmsCodeWashCar(data).then();
    },
    //立即领取
    receive() {
      if (!this.phone) {
        this.$toast("请输入手机号");
        return false;
      }
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (!reg.test(this.phone)) {
        this.$toast("请输入正确的手机号");
        return false;
      }
      if (!this.code) {
        this.$toast("请输入验证码");
        return false;
      }
      checkSmsCode({
        phoneNum: this.phone,
        verifyCode: this.code,
        utmSource: "c2c"
      }).then(res => {
        if (res.code === 200) {
          addSensorsTrack("ActivitiesRegistration", {
            userType: res.result.newCoupon === 0 ? "注册" : "登陆",
            prizeName: "车主服务注册领券活动202011",
            $url: window.location.href
          });
          addSensorsTrack("webCustomButtonClick", {
            $element_content: "tijiao",
            $url: window.location.href
          });
          this.$router.push({
            path: "/C2C/receive-success?newCoupon=" + res.result.newCoupon
          });
        } else {
          this.$toast(res.message);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.main-cotent {
  width: 100%;
  height: 100vh;
  background: rgb(250, 249, 248);
  position: relative;
  img {
    width: 100%;
    float: left;
  }
  .input-1 {
    width: 518px;
    height: 53px;
    line-height: 53px;
    position: absolute;
    left: 148px;
    top: 558px;
    background: transparent;
    border: none;
    padding-left: 100px;
    box-sizing: border-box;
  }
  .input-2 {
    top: 646px;
  }
  .btn-1 {
    height: 33px;
    min-width: 150px;
    position: absolute;
    top: 656px;
    right: 85px;
    background: transparent;
    border: transparent;
    font-family: MicrosoftYaHei;
    font-size: 25px;
    color: #e6a41b;
  }
  .btn-2 {
    width: 662px;
    height: 130px;
    position: absolute;
    left: 44px;
    top: 742px;
    background: transparent;
    border: none;
  }
}
</style>
